import React from 'react';
import { MdOutlineInfo } from 'react-icons/md';

import Modal, { ModalType } from '../../common/components/modal/Modal';
import Button, { ButtonType } from '../../common/components/button/Button';

type FeatureReminderModal = {
  title: string;
  description: string | React.ReactNode;
  imageSrc?: string;
  isVisible: boolean;
  testId?: string;
  onPressContinue: () => void;
};

const FeatureReminderModal: React.FC<FeatureReminderModal> = ({
  title,
  description,
  imageSrc,
  isVisible,
  testId,
  onPressContinue
}) => (
  <Modal type={ModalType.VERY_SMALL} visible={isVisible}>
    <div
      className="p-8 h-full flex flex-col justify-between gap-4"
      data-testid={testId}
    >
      <div className="flex items-center">
        <div className="h-8 w-8 flex items-center justify-center bg-primary-200 rounded-lg mr-2">
          <MdOutlineInfo size={16} className="text-primary-400" />
        </div>
        <h1 className="text-base">Feature Reminder</h1>
      </div>

      {imageSrc && <img src={imageSrc} className="w-56 md:w-64 mx-auto" />}

      <div>
        <h1 className="text-xl">{title}</h1>
        <p className="mt-4 text-base font-normal">{description}</p>
      </div>

      <Button type={ButtonType.Primary} onClick={onPressContinue}>
        Continue
      </Button>
    </div>
  </Modal>
);

export default FeatureReminderModal;
